import { getFormSubmitEvent } from '@app/components/common/analytics/analyticsUtils';
import {
  PCC_HEADLESS_BLOCKS_CATEGORY_PAGES,
  PCC_RELEASE_HEADLESS_PDP_FLAG
} from '@app/constants/featureFlags';
import {
  HeaderSearchBarSuggestion,
  HeaderSearchBarSuggestionList
} from '@cat-ecom/pcc-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTracking } from 'react-tracking';

export const SuggestionList = ({
  initialSearchValue,
  searchValue,
  isHeadlessSearchEnabled
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();

  const categoryLabel = t('MEQ_SUG_CAT');
  const productLabel = t('SUGGESTED_PRODUCTS');
  const keywordLabel = t('SUGGESTED_KEYWORDS');

  const suggestedCategories =
    useSelector(
      s => s.partsFilter.filter?.searchSuggestions?.suggestedCategories
    ) || [];
  const suggestedProducts =
    useSelector(
      s => s.partsFilter.filter?.searchSuggestions?.suggestedProducts
    ) || [];
  const suggestedKeywords =
    useSelector(
      s => s.partsFilter.filter?.searchSuggestions?.suggestedKeyWords
    ) || [];
  const isHeadlessCategoryEnabled = useSelector(
    s => s.featureFlag[PCC_HEADLESS_BLOCKS_CATEGORY_PAGES]
  );
  const esiteURL = useSelector(s => s.common?.esiteURL);
  const isPDPHeadlessFeatureFlagEnable =
    useSelector(s => s.featureFlag[PCC_RELEASE_HEADLESS_PDP_FLAG]) ?? false;
  const seoURL = useSelector(s => s.dealer.seoURL);

  const searchedValue = initialSearchValue || searchValue;

  const trackItemSelection = displayName => {
    trackEvent(
      getFormSubmitEvent({
        formName: 'search',
        formContent: searchedValue,
        formContent2: displayName
      })
    );
  };

  suggestedKeywords.forEach(keyword => {
    keyword.value = isHeadlessSearchEnabled
      ? `${esiteURL}${keyword.value}`
      : keyword.value;
  });

  suggestedProducts.forEach(product => {
    product.value = isPDPHeadlessFeatureFlagEnable
      ? `${esiteURL}/product/${product.partNumber}`
      : product.value;
  });

  return (
    <HeaderSearchBarSuggestionList>
      <HeaderSearchBarSuggestion
        label={keywordLabel}
        items={suggestedKeywords}
        highlightText={searchedValue}
        onItemClick={trackItemSelection}
      />
      <HeaderSearchBarSuggestion
        label={productLabel}
        items={suggestedProducts}
        highlightText={searchedValue}
        onItemClick={trackItemSelection}
      />
      <HeaderSearchBarSuggestion
        label={categoryLabel}
        items={suggestedCategories}
        highlightText={searchedValue}
        onItemClick={trackItemSelection}
        seoURL={seoURL}
        isHeadlessCategoryEnabled={isHeadlessCategoryEnabled}
      />
    </HeaderSearchBarSuggestionList>
  );
};

SuggestionList.propTypes = {
  initialSearchValue: PropTypes.string,
  searchValue: PropTypes.string,
  isHeadlessSearchEnabled: PropTypes.bool,
  isPDPHeadlessFeatureFlagEnable: PropTypes.bool
};
